import jsPDF from "jspdf";
import "jspdf-autotable";

import AuditSXLogo from "../../../assets/AuditSX-logo.png";

export const patientCarePDFReport = (patientCareRecords) => {
  const doc = new jsPDF();

  const headingText = "AuditSX:\nPatient Care Report Summary";

  const addHeader = (doc, currentY) => {
    doc.addImage(AuditSXLogo, "PNG", 15, currentY, 54, 15);

    doc.setFontSize(13);
    doc.text(headingText, 120, currentY + 6);

    return currentY + 25;
  };

  let currentY = 20; // Initial Y position for the first record

  // Add the header for the first page
  currentY = addHeader(doc, currentY);

  doc.setFontSize(10);

  doc.autoTable({
    startY: currentY,
    head: [
      [
        "Date",
        "Resident Name",
        "Facility",
        "Unit",
        "Personal Care Audit",
        "Resident Environment",
        "Mobility Aids",
        "PCC",
      ],
    ],
    body: patientCareRecords.map((record) => [
      new Date(record.createdAt).toLocaleString(),
      record.residentName,
      record.facility,
      record.unit,
      record.personalCareAudit.compliance.percentage >= 0.6
        ? "Compliant"
        : "Non-compliant",
      record.residentEnvironment.compliance.percentage >= 0.6
        ? "Compliant"
        : "Non-compliant",
      record.mobilityAids.compliance.percentage >= 0.6
        ? "Compliant"
        : "Non-compliant",
      record.pcc.compliance.percentage >= 0.6 ? "Compliant" : "Non-compliant",
    ]),
  });

  doc.save(`patient_care_report_${new Date().toISOString()}.pdf`);
};
